import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import { StyledInput } from "../../ui-kit/input";

import Select from "react-select";
import { Button } from "../../ui-kit/styled-templates";

const HIDE_OPTIONS = [
    {
        label: "Показывать",
        value: false
    },
    {
        label: "Скрывать",
        value: true
    }
];

export default function UpdateAmbassadorInfoForm(props) {

    const {
        loading = false,
        onSave = d => {

        }
    } = props;

    const [ambassadorAboutMe, setAmbassadorAboutMe] = useState(props.ambassadorAboutMe || "");
    const [city, setCity] = useState(props.city || "");
    const [ambassadorSocialLinksInfo, setAmbassadorSocialLinksInfo] = useState(props.ambassadorSocialLinksInfo || "");
    const [ambassadorContactsInfo, setAmbassadorContactsInfo] = useState(props.ambassadorContactsInfo || "");
    const [ambassadorNickname, setAmbassadorNickname] = useState(props.ambassadorNickname || "");

    const [ambassadorHideContacts, setAmbassadorHideContacts] = useState(props.ambassadorHideContacts || false);

    return (
        <Wrapper>

            <Row>
                <Label>
                    Информация обо мне (кратко)
                </Label>
                <Textarea
                    value={ambassadorAboutMe}
                    placeholder={""}
                    onChange={e => {
                        setAmbassadorAboutMe(e.target.value);
                    }}
                />
            </Row>

            <Row>
                <Label>
                    Информация о соц. сетях
                </Label>
                <Textarea
                    value={ambassadorSocialLinksInfo}
                    placeholder={""}
                    onChange={e => {
                        setAmbassadorSocialLinksInfo(e.target.value);
                    }}
                />
            </Row>

            <Row>
                <Label>
                    Контакты
                </Label>
                <Textarea
                    value={ambassadorContactsInfo}
                    placeholder={""}
                    onChange={e => {
                        setAmbassadorContactsInfo(e.target.value);
                    }}
                />
            </Row>

            <Row>
                <Label>
                    Никнейм
                </Label>
                <Input
                    value={ambassadorNickname}
                    placeholder={""}
                    onChange={e => {
                        setAmbassadorNickname(e.target.value);
                    }}
                />
            </Row>


            <Row>
                <Label>
                    Город
                </Label>
                <Input
                    value={city}
                    placeholder={""}
                    onChange={e => {
                        setCity(e.target.value);
                    }}
                />
            </Row>

            <Row>
                <Label>
                    Контакты для всех, кроме ВУЗов
                </Label>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: 20 }}>
                    <div style={{ marginRight: 20 }} onClick={() => {
                        setAmbassadorHideContacts(!(ambassadorHideContacts == undefined ? true : ambassadorHideContacts));
                    }}>
                        <input type="checkbox"
                               checked={(ambassadorHideContacts == undefined ? true : ambassadorHideContacts) == true}

                        />
                        <span style={{ marginLeft: 10 }}>
                                    {"Скрывать контакты для всех, кроме ВУЗов "}
                                </span>
                    </div>
                    {/*{HIDE_OPTIONS.map((a, i) => {*/}
                    {/*    return (*/}
                    {/*        <div key={i} style={{ marginRight: 20 }} onClick={() => {*/}
                    {/*            setAmbassadorHideContacts(a.value);*/}
                    {/*        }}>*/}
                    {/*            <input type="checkbox"*/}
                    {/*                   checked={ambassadorHideContacts == a.value}*/}

                    {/*            />*/}
                    {/*            <span style={{ marginLeft: 10 }}>*/}
                    {/*                {a.label}*/}
                    {/*            </span>*/}
                    {/*        </div>*/}
                    {/*    );*/}
                    {/*})}*/}
                </div>
            </Row>

            <Row style={{ marginTop: 50 }}>
                <Button onClick={() => {
                    if (loading == true) {
                        return;
                    }
                    onSave({
                        ambassadorAboutMe,
                        ambassadorSocialLinksInfo,
                        ambassadorContactsInfo,
                        ambassadorNickname,
                        ambassadorHideContacts,
                        city
                    });
                }}>
                    {loading == true ? "..." : "Cохранить"}
                </Button>
            </Row>


        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const Label = styled.div`
  font-weight: bold;
`;

const Row = styled.div`
  margin-bottom: 10px;
`;

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  border: 1px solid lightgrey;
  outline: none;
  font-size: 16px;
  border-radius: 6px;
  padding-left: 5px;

  :focus {
    border-color: blue;
  }
`;

const Textarea = styled.textarea`
  box-sizing: border-box;
  padding-left: 5px;
  width: 100%;
  border: 1px solid lightgrey;
  outline: none;
  font-size: 16px;
  border-radius: 6px;
  min-height: 6em;

  :focus {
    border-color: blue;
  }
`;